import styled from 'styled-components';

const TextAdminHome = styled.h3`
  font-size: 20px;
  color: white;
  display: flex;
  justify-content: center;
`

const TitleAdminHome = styled.h1`
  font-size: 24px;
  color: white;
  display: flex;
  justify-content: center;
`

export { TextAdminHome, TitleAdminHome }